interface NavLink {
  id: string;
  href?: string;
}

// Target of the Sensu wordmark: the events view of the current namespace,
// with the same default filter as the namespace landing redirect.
export const getHomeHref = (links: NavLink[]): string | undefined => {
  const events = links.find((link) => link.id === "events" && !!link.href);
  if (!events || !events.href) {
    return undefined;
  }
  if (events.href.indexOf("filters=status:incident") !== -1) {
    return events.href;
  }
  return `${events.href}?filters=status:incident`;
};
